import { IRootState } from '../../../store'
import { IOptions } from '../../../common/common.types'

export const getPreferredLanguageOptionsSelector = (state: IRootState): { preferredLanguageOptions: IOptions } => ({
  preferredLanguageOptions: state.options.patientDemographicsOptions.preferredLanguageOptions,
})
